export var isChrome =
  typeof window === 'object' &&
  /Chrome/.test(navigator.userAgent) &&
  /Google Inc/.test(navigator.vendor);
export var isFirefox =
  typeof window === 'object' && /firefox/.test(navigator.userAgent.toLowerCase());
export var isSafari =
  typeof window === 'object' &&
  /Safari/.test(navigator.userAgent) &&
  /Apple Computer/.test(navigator.vendor);

export function getSafariVersion() {
  var version = false;
  if (isSafari) {
    let matches = /Version\/(\d*)/.exec(navigator.userAgent);
    if (matches && matches.length > 0) {
      version = parseInt(matches[1], 10);
    }
  }
  return version;
}
